import React, { useState } from 'react';
import NotesPopup from './ChatComponents/NotesPopup';
import Icon from '../../globalcomponents/Icon';
import { useTheme } from 'styled-components';

const ArchiveContainer = props => {
  const {
    isArchived,
    selectedLeadId,
    leadUpdateMutate,
    setArchiveClick,
    archiveClick,
    newNoteInsertionInProgress,
    handleOutgoingMessage,
    handleNoteCreation,
    handleCallLogCreation
  } = props;
  const theme = useTheme();

  const [open, setOpen] = useState(false);

  const updateArchiveStatus = () => {
    setArchiveClick(true);
    let archiveBody = {
      isArchived: !isArchived
    };
    if (!isArchived) {
      archiveBody.isAgentProcessingLead = false;
    }
    if (selectedLeadId) {
      if (leadUpdateMutate) {
        leadUpdateMutate({
          variables: { leadId: selectedLeadId, record: archiveBody }
        });
      }
    }
  };
  return (
    <div className="d-flex-row">
      <figure className="figure cursor-pointer" style={{ margin: '15px 8px' }}>
        {archiveClick ? (
          <div className="archive-loader" />
        ) : isArchived ? (
          theme.state === 'light' ? (
            <Icon
              src="archive-out.svg"
              tooltipText="Un-archive lead"
              onClick={updateArchiveStatus}
              alt="Unarchive lead"
            />
          ) : (
            <Icon
              src="archive-out-dark.svg"
              onClick={updateArchiveStatus}
              tooltipText="Un-archive lead"
              alt="Unarchive lead"
            />
          )
        ) : theme.state === 'light' ? (
          <Icon
            src="archive-in.svg"
            tooltipText="Archive lead"
            onClick={updateArchiveStatus}
            alt="Archive lead"
          />
        ) : (
          <Icon
            src="archive-dark.svg"
            onClick={updateArchiveStatus}
            tooltipText="Archive lead"
            alt="Archive lead"
          />
        )}
      </figure>

      <figure style={{ margin: '15px 8px' }} className="figure cursor-pointer">
        {theme.state === 'light' ? (
          <Icon
            src="notes.svg"
            tooltipText="Notes"
            onClick={() => setOpen(!open)}
          />
        ) : (
          <Icon
            src="notes-dark.svg"
            tooltipText="Notes"
            onClick={() => setOpen(!open)}
          />
        )}
      </figure>

      <NotesPopup
        {...{
          open,
          setOpen,
          selectedLeadId,
          newNoteInsertionInProgress,
          handleOutgoingMessage,
          handleNoteCreation,
          handleCallLogCreation
        }}
      />
    </div>
  );
};

export default ArchiveContainer;
